<template>
  <div class="box-form box-form-products">
    <v-form>
      <v-card-text class="modal-cadastro-form">
        <v-row class="align-center">
          
            <!-- <v-select
              v-model="type"
              :items="listaTypesContract"
              item-text="name"
              item-value="id"
            /> -->

            <v-col cols="12" class="modal-cadastro-form-col-imput">
              <v-skeleton-loader
                :loading="loadingSkeleton"
                :transition="'fade-transition'"
                width="100%"
                type="chip">
                <div class="d-flex mb-4">
                  <v-btn
                    rounded
                    color="primary"
                    dark
                    v-for="type in listaTypesContract"
                    :key="type.id"
                    :outlined="!(type.id === typeContractSelected)"
                    @click="setTypeContract(type.id)"
                    class="mr-2"
                  >
                    {{ type.name }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </v-col>
          <v-col cols="5" class="modal-cadastro-form-col-imput">
            <v-autocomplete
              v-model="contrato"
              :items="listaItensContratos"
              label=""
              item-text="name"
              item-value="id"
              dense
              :error-messages="contratoErrors"
              return-object
              :loading="loadingContratos"
              @input="$v.contrato.$touch()"
              @blur="$v.contrato.$touch()"
            />
          </v-col>
            <v-col cols="2" class="modal-cadastro-form-col-imput" > 
                <!-- Tipos de contratos -->
                <v-select
                  tabindex="1"
                  class="contrato"
                  v-model="payIntervalType"
                  :items="[{ text: 'Dia', value: 'DAY'}]"
                  label="Tipo de intervalo:"
                  item-text="text"
                  item-value="value"
                  dense
                  @input="$v.payIntervalType.$touch()"
                  @blur="$v.payIntervalType.$touch()"
                  :error-messages="payIntervalTypeErrors" />
              </v-col>

              <v-col cols="2" class="modal-cadastro-form-col-imput" > 
                <!-- Tipos de contratos -->
                <v-currency-field
                  :autoDecimalMode="false"
                  :decimalLength="0"
                  :valueAsInteger="true"
                  v-model="payIntervalQty"
                  label="Intervalo:"
                  :precision="{min: 0, max: 0}"
                  :useGrouping="false"
                  prefix=""
                  @input="$v.payIntervalQty.$touch()" 
                  @blur="$v.payIntervalQty.$touch()"
                  dense 
                  :error-messages="payIntervalQtyErrors" />
              </v-col>
          <v-col cols="3" class="modal-cadastro-form-col-imput">
            <v-btn
              :color="variables.colorPrimary"
              @click.prevent="adicionarContrato"
              class="br-btn"
              :loading="loading"
              dense>Adicionar</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <template v-for="(data, idx) in itensContratos">
            <v-col cols="6" class="modal-cadastro-form-col-imput" :key="idx">
              <v-card
                class="mx-auto mb-4"
                max-width="550"
              >
                <v-card-title class="modal-cadastro-titulo justify-space-between py-2 px-2" color="#FFF">
                  <div>{{ data.contrato.name }} </div>
                  <v-icon @click="deleteContrato(idx)" color="#FFF">
                     mdi-delete
                  </v-icon>
                </v-card-title>

                <v-card-text>
                  <v-row align="center">
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                     <strong>Tipo: </strong>  {{ data.contrato.types.description }} ({{ data.contrato.types.id }})
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                     <strong>Intervalo de pagamento: </strong>  {{ data.payIntervalQty }} {{ data.payIntervalType }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="21"
                    >
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                De
                              </th>
                              <th class="text-left">
                                Para
                              </th>
                              <th class="text-left">
                                %
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="range in data.contrato.contractRangeValues"
                              :key="range.id"
                            >
                              <td>{{ range.minRange }}</td>
                              <td>{{ range.maxRange }}</td>
                              <td>{{ range.aliquot }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            </template>
        </v-row>
      </v-card-text>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { minValue, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
// import Events from '@/core/service/events'
// import { currency } from '@/core/service/utils'
// import { cnpj } from 'cpf-cnpj-validator'
import variables from '@/assets/styles/helpers/_variables.scss'
import { cloneDeep } from 'lodash'
// import vmoney from '@/views/components/vMoney'
import validateContrato from './validateContrato'

// const validCNPJ = (params) => {
//   console.log(params)
// }

const isValidContrato = (listaContratosAdicionados) => value => {
  return !listaContratosAdicionados.find(it => it.contrato.contractTypeId === value.contractTypeId)
}

export default {
  name: 'BrModalCadastroAts',
  mixins: [validationMixin],
  directives: {mask},
  components: {
    // comissao: () => import('./comissao')
  },
  props: {
    affiliateId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    activeModal: false,
    loading: false,
    search: '',
    divider: '/',
    loadingTable: false,
    listaContratosAdicionados: [],
    typeContractSelected: '',
    contrato: '',
    loadingContratos: false,
    loadingSkeleton: false,
    payIntervalType: 'DAY',
    payIntervalQty: 0
  }),
  watch: {
    // 'itemEntityProducts.comission' (val) {
    //   console.log(val)
    //   if (val > 100) this.itemEntityProducts.comission = 100
    // }
    'typeContractSelected' (val) {
      this.contrato = ''
      this.loadingContratos = true
      this.obterContratos({ _addlFilter: { 'ContractsAffiliate:contractTypeId_=': val } })
        .finally(() => { this.loadingContratos = false })
    }
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('afiliadosContratos', {
      listaContratos: 'itensSelect',
      listaItensContratos: 'listaItens',
      listaTypesContract: 'listaTypesContract'
    }),

    ...mapGetters('afiliadosPendentes', {
      itensContratos: 'itensContratos',
    }),
    ...validateContrato,

    variables: () => variables,
    isEdit () {
      return this.itemEntityProducts.id ? !!1 : !!0
    }
  },
  mounted () {
    this.loadingSkeleton = true
    this.obterTiposDeContratos()
      .finally(() => { this.loadingSkeleton = false })
    this.obterContratosCadastrados(this.affiliateId)
  },
  methods: {
    ...mapActions('afiliadosContratos', {
      obterContratos: 'getItens',
      obterTiposDeContratos: 'getTypesContrato',
    }),
    ...mapActions('afiliadosPendentes', {
      obterContratosCadastrados: 'obterContratosCadastrados',
      removerContrato: 'removerContrato',
      setListaContratosAdicionado: 'setListaContratosAdicionado'
    }),

    setTypeContract (typeContractId) {
      this.typeContractSelected = typeContractId
    },

    adicionarContrato () {
      if (this.$v.$invalid) { 
        this.$v.$touch()
        return false 
      }
      // this.listaContratosAdicionados.push(cloneDeep(this.contrato))
      this.setListaContratosAdicionado({ contrato: cloneDeep(this.contrato), payIntervalQty: this.payIntervalQty, payIntervalType: this.payIntervalType })
      this.contrato = ''
      this.$v.contrato.$reset()
    },

    deleteContrato (idx) {
      // this.listaContratosAdicionados.push(cloneDeep(this.contrato))
      this.removerContrato(idx)
    }
  },

  validations () {
    return  {
      contrato: {
        required,
        isValidContrato: isValidContrato(this.itensContratos)
      },
      payIntervalType: {
        required
      },
      payIntervalQty: {
        required,
        minValue: minValue(1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../assets/styles/components/formularios';
  @import '../../../../assets/styles/components/modal-cadastro';

  .v-card__text {
    overflow: auto !important;
    max-height: 500px !important;
    min-height: 148px !important;
  }

  .modal-cadastro-form{
    min-width: 100% !important;
    max-height: 100% !important;
  }

  .v-dialog:not(.v-dialog--active) {
    max-height: 100% !important;
  }
  .br-btn-entity-products {
    margin-top: 10px;
    min-width: auto !important;
    font-size: 0.8em !important;
  }
  .modal-cadastro-titulo {
    background: #6d7278;
    color: #FFF !important;
  }
  .d-flex {
    margin-bottom: 15px;
  }
</style>